import { DashboardWithStleSettings, DashletWithStyleConfig } from './types';

export const getDashletWithMergedStyles = (
  currentDashlet: DashletWithStyleConfig,
  dashboard: DashboardWithStleSettings
): DashletWithStyleConfig => {
  return {
    ...currentDashlet,
    config: {
      ...currentDashlet?.config,
      feExtraInfo: {
        ...currentDashlet?.config?.feExtraInfo,
        customStylesEnabled:
          currentDashlet?.config?.feExtraInfo?.customStylesEnabled,
        dashletStyleConfig: !currentDashlet?.config?.feExtraInfo
          ?.customStylesEnabled
          ? dashboard?.styleSettings
          : {
              ...dashboard?.styleSettings,
              ...currentDashlet?.config?.feExtraInfo?.dashletStyleConfig,
            },
      },
    },
  };
};

export const rgbaToHex = (rgba: string): string | null => {
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (!match) return null;

  const [, r, g, b, a = '1'] = match;
  const alpha = Math.round(parseFloat(a) * 255);

  const toHex = (n: string) => parseInt(n).toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}${alpha < 255 ? toHex(alpha.toString()) : ''}`.toUpperCase();
};
